import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { API, carsUrl, authFetch } from '../utils/api';
import { getSocket } from '../utils/socket';
import { FLOW, FLOW_COLOR } from '../utils/documentTypes';
import DashboardWidgets from './DashboardWidgets';
import DashboardNews from './DashboardNews';
import CustomModal from './CustomModal';
import OnboardingGuide from './OnboardingGuide';
var koLang = require('../locales/ko.json');
var arLang = require('../locales/ar.json');
var LANGS = { ko: koLang, ar: arLang };

function DashboardPage({user}){
  var [modal, setModal] = useState(null);
  var closeModal = function() { setModal(null); };
  var FLOW_ICON=['📋','🔄','✅','📄','🗂️','🚢','🎉'];
  var[lang,setLang]=useState(localStorage.getItem('autodoc_lang')||'ko');
  var t=LANGS[lang]||LANGS.ko;
  var isRTL=lang==='ar';
  var FLOW_LABELS=[t.registered,t.cancelReq,t.cancelled,t.clearanceReq,t.clearanceDone,t.shipReady,t.shipped];
  function changeLang(newLang){setLang(newLang);localStorage.setItem('autodoc_lang',newLang)}
  var[pipeline,setPipeline]=useState({});
  var[alerts,setAlerts]=useState([]);
  var[stats,setStats]=useState({thisMonthCount:0,avgDays:0});
  var[deadlineCounts,setDeadlineCounts]=useState({expired:0,urgent:0,warning:0});
  var[deadlineItems,setDeadlineItems]=useState([]);
  var[arrivalSoonCars,setArrivalSoonCars]=useState([]);
  var[customsLoading,setCustomsLoading]=useState(false);
  var[customsResult,setCustomsResult]=useState(null);
  var[notices,setNotices]=useState([]);
  var[dismissedNotices,setDismissedNotices]=useState(function(){try{return JSON.parse(sessionStorage.getItem('dismissed_notices')||'[]')}catch(e){return[]}});
  var[now,setNow]=useState(new Date());
  var[smartAlerts,setSmartAlerts]=useState([]);
  var[alertCounts,setAlertCounts]=useState({urgent:0,warn:0,info:0});
  var[expandedGroup,setExpandedGroup]=useState(null);
  var[showDismissed,setShowDismissed]=useState(false);
  var getDismissed=function(){try{var d=JSON.parse(localStorage.getItem('dismissed_alerts')||'[]');var now2=Date.now();return d.filter(function(x){return(now2-new Date(x.dismissed_at).getTime())<30*86400000})}catch(e){return[]}};
  var[dismissedAlerts,setDismissedAlerts]=useState(getDismissed);
  var isDismissed=function(id){return dismissedAlerts.some(function(x){return x.id===id})};
  var dismissAlert=function(id){setModal({type:'confirm',title:t.confirmDismiss,onConfirm:function(){closeModal();var updated=getDismissed().concat({id:id,dismissed_at:new Date().toISOString()});localStorage.setItem('dismissed_alerts',JSON.stringify(updated));setDismissedAlerts(updated)}})};
  var restoreAlert=function(id){var updated=getDismissed().filter(function(x){return x.id!==id});localStorage.setItem('dismissed_alerts',JSON.stringify(updated));setDismissedAlerts(updated)};
  var[exchangeRates,setExchangeRates]=useState([]);
  var[ratesLoading,setRatesLoading]=useState(true);
  var[ratesUpdatedAt,setRatesUpdatedAt]=useState(null);
  var[newsPopup,setNewsPopup]=useState(null);
  var[newsSummary,setNewsSummary]=useState(null);
  var[newsLoading,setNewsLoading]=useState(false);
  var[newsItems,setNewsItems]=useState([]);
  var[reportSummary,setReportSummary]=useState(null);
  var[newsItemsLoading,setNewsItemsLoading]=useState(true);
  var[newsFilter,setNewsFilter]=useState('all');
  var navigate=useNavigate();
  var[showOnboarding,setShowOnboarding]=useState(false);
  var companyId=user?(user.activeCompanyId||user.companyId||0):0;

  useEffect(function(){
    // onboarding check: 차량 0대 + localStorage 없을 때만
    if(companyId>0&&!localStorage.getItem('onboarding_done_'+companyId)){
      authFetch(API+'/cars/stats').then(function(r){return r.json()}).then(function(d){if(d&&(d.total===0||d.total===undefined))setShowOnboarding(true)}).catch(function(){});
    }
  },[companyId]);

  useEffect(function(){
    authFetch(API+'/pipeline').then(function(r){return r.json()}).then(function(d){setPipeline(d.pipeline||{});setStats({thisMonthCount:d.thisMonthCount||0,avgDays:d.avgDays||0})}).catch(function(){});
    authFetch(API+'/alerts').then(function(r){return r.json()}).then(function(d){setAlerts(d)}).catch(function(){});
    authFetch(API+'/cars/deadline-alert').then(function(r){return r.json()}).then(function(d){setDeadlineCounts(d.counts||{});setDeadlineItems(d.items||[])}).catch(function(){});
    authFetch(API+'/dashboard/arrival-soon').then(function(r){return r.json()}).then(function(d){setArrivalSoonCars(Array.isArray(d)?d:[])}).catch(function(){});
    authFetch(API+'/dashboard/smart-alerts').then(function(r){return r.json()}).then(function(d){setSmartAlerts(d.alerts||[]);setAlertCounts(d.counts||{})}).catch(function(){});
    authFetch(API+'/dashboard/notices').then(function(r){return r.json()}).then(function(d){setNotices(Array.isArray(d)?d:[])}).catch(function(){});
    var ym=new Date().toISOString().slice(0,7);authFetch(API+'/reports/monthly/'+ym).then(function(r){return r.json()}).then(function(d){if(d.success&&d.data)setReportSummary(d.data.amount)}).catch(function(){});
    var fetchNews=function(){
      authFetch(API+'/dashboard/news').then(function(r){return r.json()}).then(function(d){setNewsItems(d.items||[]);setNewsItemsLoading(false)}).catch(function(){setNewsItemsLoading(false)});
    };
    fetchNews();
    var CURRENCIES=[
      {currency:'USD',flag:'🇺🇸',name:'미국 달러'},
      {currency:'AED',flag:'🇦🇪',name:'UAE 디르함'},
      {currency:'EUR',flag:'🇪🇺',name:'유로'},
      {currency:'JPY',flag:'🇯🇵',name:'일본 엔'}
    ];
    var prevKey='autodoc_rates_prev';
    var currentKey='autodoc_rates_current';
    var fetchExchangeRates=function(){
      fetch('https://open.er-api.com/v6/latest/KRW').then(function(r){return r.json()}).then(function(todayData){
        if(todayData.result!=='success'){setRatesLoading(false);return}
        var todayRates=todayData.rates||{};
        var prevRates=null;
        try{prevRates=JSON.parse(localStorage.getItem(currentKey))}catch(e){}
        try{
          if(prevRates)localStorage.setItem(prevKey,JSON.stringify(prevRates));
          localStorage.setItem(currentKey,JSON.stringify(todayRates));
          if(!prevRates)localStorage.setItem(prevKey,JSON.stringify(todayRates));
        }catch(e){}
        var prev=null;
        try{prev=JSON.parse(localStorage.getItem(prevKey))}catch(e){}
        var result=CURRENCIES.map(function(c){
          var todayRate=todayRates[c.currency];
          if(!todayRate)return null;
          var krwRate=1/todayRate;
          var prevKrw=prev?(1/(prev[c.currency]||todayRate)):krwRate;
          var change=krwRate-prevKrw;
          var pct=prevKrw>0?(change/prevKrw*100):0;
          return{
            currency:c.currency,
            flag:c.flag,
            name:c.name,
            rate:Math.round(krwRate*100)/100,
            change:Math.round(change*100)/100,
            pct:Math.round(pct*100)/100
          };
        }).filter(function(x){return x!==null});
        setExchangeRates(result);
        setRatesLoading(false);
        setRatesUpdatedAt(new Date());
      }).catch(function(){setRatesLoading(false)});
    };
    fetchExchangeRates();
    var ratesInterval=setInterval(fetchExchangeRates,30*60*1000);
    var newsInterval=setInterval(fetchNews,30*60*1000);
    return function(){clearInterval(ratesInterval);clearInterval(newsInterval);};
  },[]);

  useEffect(function(){
    var timer=setInterval(function(){setNow(new Date())},60000);
    return function(){clearInterval(timer)};
  },[]);

  // WebSocket 실시간 갱신
  useEffect(function(){var s=getSocket();if(!s)return;var refresh=function(){authFetch(API+'/pipeline').then(function(r){return r.json()}).then(function(d){setPipeline(d.pipeline||{});setStats({thisMonthCount:d.thisMonthCount||0,avgDays:d.avgDays||0})}).catch(function(){});authFetch(API+'/alerts').then(function(r){return r.json()}).then(function(d){setAlerts(d)}).catch(function(){})};s.on('car:updated',refresh);s.on('car:statusChanged',refresh);s.on('doc:uploaded',refresh);s.on('invoice:updated',refresh);return function(){s.off('car:updated',refresh);s.off('car:statusChanged',refresh);s.off('doc:uploaded',refresh);s.off('invoice:updated',refresh)}},[]);

  var total=0; FLOW.forEach(function(f){total+=(pipeline[f]||0)});

  var[buyerPayments,setBuyerPayments]=useState([]);
  useEffect(function(){
    authFetch(API+'/dashboard/payment-status').then(function(r){return r.json()}).then(function(d){
      if(Array.isArray(d)){
        setBuyerPayments(d.map(function(b){
          var st=b.status==='partial'?'잔금대기':'미입금';
          var sk=b.status==='partial'?'partialPayment':'unpaid';
          return{name:b.name,tel:b.tel||'',country:'',total:Math.round((b.total||0)/10000),paid:Math.round((b.paid||0)/10000),status:st,statusKey:sk,cars:b.cars,invoiceDate:b.earliestDate||'',lastPaidDate:'',buyerId:b.buyerId,earliestDate:b.earliestDate||''};
        }));
      }
    }).catch(function(){});
  },[]);

  var[monthlyData,setMonthlyData]=useState([]);
  var[chartMax,setChartMax]=useState(1);
  useEffect(function(){
    var now2=new Date();var ym=now2.getFullYear()+'-'+('0'+(now2.getMonth()+1)).slice(-2);
    authFetch(API+'/ledger/dashboard/'+ym).then(function(r){return r.json()}).then(function(d){
      if(d.monthlyData&&d.monthlyData.length>0){
        var md=d.monthlyData.map(function(m){
          var parts=m.month.split('-');var mo=parseInt(parts[1])||0;
          return{month:mo+'월',매출:Math.round((m.sell||0)/10000),매입:Math.round((m.buy||0)/10000),순익:Math.round((m.profit||0)/10000),대수:m.carCount};
        });
        setMonthlyData(md);
        setChartMax(Math.max.apply(null,md.map(function(x){return Math.max(x.매출,x.매입,Math.abs(x.순익||0))}))||1);
      }
    }).catch(function(){});
  },[]);

  // 입금 내역 위젯 (Wave 3, 2026-05-16) — 바이어 입금 분쟁 증거기록용
  var[recentDeposits,setRecentDeposits]=useState({days:[]});
  var[depositsDays,setDepositsDays]=useState(30);
  var loadRecentDeposits=function(d){
    authFetch(API+'/dashboard/recent-deposits?days='+d).then(function(r){return r.json()}).then(function(data){
      setRecentDeposits({days:Array.isArray(data&&data.days)?data.days:[]});
    }).catch(function(){setRecentDeposits({days:[]})});
  };
  useEffect(function(){loadRecentDeposits(depositsDays)},[depositsDays]);
  // 소켓 갱신 — bulk-paid / 일반 car:updated 모두 반영
  var depositsRef=React.useRef();
  depositsRef.current=function(){loadRecentDeposits(depositsDays)};
  useEffect(function(){
    var s=getSocket();if(!s)return;
    var h=function(){depositsRef.current&&depositsRef.current()};
    s.on('car:updated',h);
    return function(){s.off('car:updated',h)};
  },[]);

  var NEWS_FILTER_TABS=[
    {id:'all',label:t.all},
    {id:'korea',label:'🇰🇷 '+t.korea},
    {id:'mideast',label:'🇦🇪 '+t.mideast},
    {id:'centrasia',label:'🇰🇿 '+t.centrasia},
    {id:'africa',label:'🌍 '+t.africa},
    {id:'global',label:'🌐 '+t.global}
  ];

  var filteredNews=newsFilter==='all'?newsItems:newsItems.filter(function(n){return n.region===newsFilter});

  var openNewsSummary=function(item){
    setNewsPopup(item);
    setNewsSummary(null);
    setNewsLoading(true);
    authFetch(API+'/dashboard/news/summarize',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({url:item.url||'',title:item.title,description:item.description||'',lang:lang})
    }).then(function(r){return r.json()}).then(function(d){
      if(d.error){setNewsSummary({error:d.error});setNewsLoading(false);return}
      setNewsSummary(d);
      setNewsLoading(false);
    }).catch(function(e){
      setNewsSummary({error:'요약 요청 실패'});
      setNewsLoading(false);
    });
  };

  return(<div style={{maxWidth:1400,margin:'0 auto',direction:isRTL?'rtl':'ltr',textAlign:isRTL?'right':'left'}}>
    {showOnboarding&&<OnboardingGuide companyId={companyId} onClose={function(){setShowOnboarding(false)}} onGoRegister={function(){setShowOnboarding(false);navigate('/main/car-register')}}/>}
    <DashboardWidgets
      t={t} isRTL={isRTL} lang={lang} changeLang={changeLang}
      pipeline={pipeline} stats={stats} total={total}
      FLOW={FLOW} FLOW_COLOR={FLOW_COLOR} FLOW_ICON={FLOW_ICON} FLOW_LABELS={FLOW_LABELS}
      smartAlerts={smartAlerts} alertCounts={alertCounts}
      expandedGroup={expandedGroup} setExpandedGroup={setExpandedGroup}
      showDismissed={showDismissed} setShowDismissed={setShowDismissed}
      dismissedAlerts={dismissedAlerts} isDismissed={isDismissed}
      dismissAlert={dismissAlert} restoreAlert={restoreAlert}
      deadlineCounts={deadlineCounts} deadlineItems={deadlineItems}
      customsLoading={customsLoading} setCustomsLoading={setCustomsLoading}
      customsResult={customsResult} setCustomsResult={setCustomsResult}
      navigate={navigate} API={API} authFetch={authFetch}
      buyerPayments={buyerPayments} monthlyData={monthlyData} chartMax={chartMax}
      recentDeposits={recentDeposits} depositsDays={depositsDays} setDepositsDays={setDepositsDays}
      arrivalSoonCars={arrivalSoonCars}
      notices={notices} dismissedNotices={dismissedNotices} setDismissedNotices={setDismissedNotices}
      now={now} user={user}
      reportSummary={reportSummary}
    />
    <DashboardNews
      t={t} isRTL={isRTL} lang={lang} now={now}
      newsItems={newsItems} newsItemsLoading={newsItemsLoading}
      newsFilter={newsFilter} setNewsFilter={setNewsFilter}
      filteredNews={filteredNews} openNewsSummary={openNewsSummary}
      newsPopup={newsPopup} setNewsPopup={setNewsPopup}
      newsSummary={newsSummary} newsLoading={newsLoading}
      exchangeRates={exchangeRates} ratesLoading={ratesLoading}
      ratesUpdatedAt={ratesUpdatedAt}
      NEWS_FILTER_TABS={NEWS_FILTER_TABS}
    />
    {modal && <CustomModal isOpen={true} {...modal} onCancel={closeModal} />}
  </div>);
}

export default DashboardPage;
